import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';

export default function StyledNotistack() {
  const theme = useTheme();

  const isLight = theme.palette.mode === 'light';

  const inputGlobalStyles = (
    <GlobalStyles
      styles={{
        '#root': {
          '.SnackbarContent-root': {
            width: '100%',
            padding: theme.spacing(1),
            margin: theme.spacing(0.25, 0),
            boxShadow: 'none',
            borderRadius: theme.shape.borderRadius,
            color: isLight ? theme.palette.common.white : theme.palette.grey[800],
            backgroundColor: isLight ? theme.palette.grey[900] : theme.palette.common.white,
            '&.SnackbarItem-variantSuccess': {
              color: theme.palette.success.darker,
              backgroundColor: theme.palette.success.lighter,
            },
            '&.SnackbarItem-variantError': {
              color: theme.palette.error.darker,
              backgroundColor: theme.palette.error.lighter,
            },
            '&.SnackbarItem-variantWarning': {
              color: theme.palette.warning.darker,
              backgroundColor: theme.palette.warning.lighter,
            },
            '&.SnackbarItem-variantInfo': {
              color: theme.palette.info.darker,
              backgroundColor: theme.palette.info.lighter,
            },
            [theme.breakpoints.between('sm', 'md')]: {
              minWidth: 500,
            },
            [theme.breakpoints.up('md')]: {
              minWidth: 240,
            },
          },
          '.SnackbarItem-message': {
            padding: '0 !important',
            fontWeight: theme.typography.fontWeightMedium,
          },
          '.SnackbarItem-action': {
            marginRight: 0,
            color: theme.palette.action.active,

            '& svg': {
              width: 20,
              height: 20,
            },
          },
        },
      }}
    />
  );

  return inputGlobalStyles;
}
